<template>
  <div class="hp-animation u-wrapper-panel u-z-back u-bg-white" :class="{'is-leaving': isLeaving}" @click="center">
    <div class="u-pointer-none u-force-3d">
      <img ref="items" class="hp-animation__item u-round u-overflow-hidden" v-for="item in items" :src="item">
      <img v-if="$device.width > 1100" ref="items" class="hp-animation__item u-round u-overflow-hidden" v-for="item in items" :src="item">
    </div>
    <div class="hp-animation__logo u-center u-full-width" :class="{'is-visible': isVisible}" >
      <img class="u-w1of12 u-w2of12--sm" src="/images/bright__logo--custom.png">
      <div class="hp-animation__titles t-h3 t-bold u-marg-t-lg">COMMUNIQUEZ</br>AVEC DES CONTENUS VIVANTS</div>
      <app-button class="u-inline-block u-marg-t-xl" @click="onClick">
        {{ $device.isTouch ? 'Touchez pour continuer' : 'Cliquez pour continuer' }}
      </app-button>
    </div>
  </div>
</template>

<script>
import {
  Engine,
  Runner,
  World,
  Composite,
  Body,
  Bodies
} from 'matter-js'

import AppButton from '@/components/common/AppButton'

const baseWidth = 50

export default {

  components: {
    AppButton
  },

  data () {
    return {
      isVisible: false,
      isLeaving: false,
      items: [
        '/images/loader/1.jpg',
        '/images/loader/2.jpg',
        '/images/loader/3.jpg',
        '/images/loader/4.jpg',
        '/images/loader/5.jpg',
        '/images/loader/6.jpg',
        '/images/loader/7.jpg',
        '/images/loader/8.jpg',
      ]
    }
  },

  created () {
    this.circles = []
    this.isInit = false
    this.widths = [];
  },

  mounted () {
    this.start()

    setTimeout(() => {
      this.isVisible = true
    }, 1000)
  },

  beforeDestroy () {
    if (!this.engine) return
    World.clear(this.engine.world);
    Engine.clear(this.engine);
    window.removeEventListener('mousemove', this.onMousemove, { passive: true })
  },

  methods: {
    onClick () {
      this.isLeaving = true
      this.$emit('readyToSetup')

      setTimeout(() => {
        this.$emit('finished')
      }, 1500)
    },
    start () {
      setTimeout(()=>{
        this.center(false)
      },1000)

      requestAnimationFrame(this.initPhysics)
    },

    initPhysics () {
      this.engine = Engine.create({
        gravity: {
          x: 0,
          y: 0,
          scale: 0.001
        }
      })
      this.world = this.engine.world
      // this.runner = Runner.create()

      this.$refs.items.forEach((item, index) => {
        const position = {
          x: Math.random() * this.$device.width,
          y: Math.random() * this.$device.height
        }

        this.widths[index] = Math.floor(Math.random() * baseWidth + baseWidth)
        this.widths[index] *= this.$device.isMobile ? .7 : 1

        item.style.width = (this.widths[index] * 2) + 'px'
        item.style.height = (this.widths[index] * 2) + 'px'
        item.style.transform = `translate3d(${position.x - this.widths[index]}px, ${position.y - this.widths[index]}px, 0)}rad)`

        this.circles.push(Bodies.circle(position.x, position.y, this.widths[index], {}, 15))
      })

      Composite.add(this.world, this.circles)

      this.mouseCircle = Bodies.circle(0, 0, baseWidth)
      Composite.add(this.world, this.mouseCircle)

      Composite.add(this.world, [
        Bodies.rectangle(this.$device.width * .5, -50, this.$device.width * 2, 100, { isStatic: true }),
        Bodies.rectangle(this.$device.width + 50, this.$device.height * .5, 100, this.$device.height * 2, { isStatic: true }),
        Bodies.rectangle(this.$device.width * .5, this.$device.height +50, this.$device.width * 2, 100, { isStatic: true }),
        Bodies.rectangle(-50, this.$device.height * .5, 100, this.$device.height * 2, { isStatic: true })
      ])

      // This shit burns perfs down
      // window.addEventListener('mousemove', this.onMousemove, { passive: true })
      this.isInit = true
    },

    onMousemove (event) {
      const pos = this.$device.getPointerPosition(event)
      this.mouseCircle.position.x = pos.x
      this.mouseCircle.position.y = pos.y
    },

    onUpdate (time) {
      if (!this.isInit) {return}

      // time.delta
      Engine.update(this.engine, 16.666, 1)

      this.$refs.items.forEach((item, index) => {
        const circle = this.circles[index]
        item.style.transform = `translate3d(${circle.position.x - this.widths[index]}px, ${circle.position.y - this.widths[index]}px, 0) rotate(${circle.angle}rad)`
      })
    },

    center () {
      const halfWidth = this.$device.width *.5
      const halfHeight = this.$device.height *.5
      const force = Math.random() * .5 + .5

      for (let i = 0; i < this.circles.length; i++) {
        if (this.circles[i].position.x < halfWidth && this.circles[i].position.y < halfHeight) {
          Body.applyForce(this.circles[i], {x: halfWidth, y: halfHeight}, {x: force, y: force})
        }
        else if (this.circles[i].position.x >= halfWidth && this.circles[i].position.y < halfHeight) {
          Body.applyForce(this.circles[i], {x: halfWidth, y: halfHeight}, {x: -force, y: force})
        }
        else if (this.circles[i].position.x < halfWidth && this.circles[i].position.y >= halfHeight) {
          Body.applyForce(this.circles[i], {x: halfWidth, y: halfHeight}, {x: force, y: -force})
        }
        else {
          Body.applyForce(this.circles[i], {x: halfWidth, y: halfHeight}, {x: -force, y: -force})
        }
      }
    },
  },
}
</script>

<style lang="stylus">
@import '~@/styles/settings/variables'
@import '~@/styles/settings/easings'
@import '~@/styles/settings/mixins/mq'

.hp-animation
  transition .5s

  &__item
    position absolute
    top 0
    left 0
    pointer-events none
    will-change transform

  &__logo
    position absolute
    top 50%
    left 50%
    width 20%
    min-width 300px
    opacity 0
    transform translate(-50%, -50%)
    transition opacity 1s linear

    &.is-visible 
      opacity 1
    
  &:after
    content ''
    position absolute
    top 50%
    left 50%
    width 300vw
    height 300vw
    border-radius 50%
    background-color: $colors.blue
    transform translate3d(-50%, -50%, 0) scale(.001, .001)
    transition transform 1.5s ease-in-quint
    opacity 0
    
  &.is-leaving:after
    opacity 1
    transform translate3d(-50%, -50%, 0) scale(1, 1)
  
  &__titles
    +mq($from: 'wide')
      font-size 70px
      line-height 70px
      
</style>